var _rect, _rect2, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCloudBg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 32,
    viewBox: "0 0 42 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 41,
    height: 31,
    rx: 3.5,
    fill: "#EEEEEE"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 41,
    height: 31,
    rx: 3.5,
    stroke: "#C7C7C7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.0007 20.0028H17.4387C15.724 20.0001 14.334 18.6621 14.334 17.0114C14.334 15.3614 15.724 14.0234 17.4387 14.0234C17.7007 12.8488 18.6347 11.8901 19.8887 11.5081C21.142 11.1268 22.526 11.3794 23.518 12.1748C24.51 12.9681 24.9593 14.1794 24.698 15.3541H25.358C26.278 15.3541 27.0733 15.8961 27.4447 16.6808M25.6673 18.6668V22.6668M25.6673 22.6668L27.6673 20.6668M25.6673 22.6668L23.6673 20.6668",
    stroke: "#00332D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloudBg);
export default __webpack_public_path__ + "static/media/cloudBg.910e15507fdf3538dda4f2bde98e80d6.svg";
export { ForwardRef as ReactComponent };